export default __webpack_public_path__ + "static/media/I10402.b775fe93.jpg";